<div *ngIf="listOnly">
        {{options[value].title}} <mat-icon *ngIf="options[value].icon" color="{{options[value].color}}">flag</mat-icon>
</div>
<mat-form-field *ngIf="!listOnly">
    <mat-select placeholder="Priority" name="priority" [formControl]="control" [disabled]="canEdit === false">
        <mat-select-trigger>
                {{control.value >= 0 ? options[control.value].title : ''}}
                <mat-icon *ngIf="control.value >= 0 && options[control.value].icon" color="{{options[control.value].color}}">flag</mat-icon>
        </mat-select-trigger>
        <mat-option *ngFor="let priority of options" [value]="priority.value">
            {{priority.title}} <mat-icon *ngIf="priority.icon" color="{{priority.color}}">flag</mat-icon>
        </mat-option>
    </mat-select>
</mat-form-field>